import cookie from "modules/cookie";
import languageListTemplate from "./CountrySelector.hbs";
import notificationTemplate from "../Notifications/Notifications.hbs";

import { Component } from "modules/Component";
import { countriesApi as cApi, CountriesApi, Country } from "api/CountriesApi";
import { NotificationApi, notificationApi as nApi } from "api/NotificationApi";

export class CountrySelector extends Component<typeof CountrySelector> {
    public static className: string = "js-country-selector-component";

    private store = {
        countries: [] as Country[],
    }

    constructor(
        protected readonly countrySelectorElement: HTMLElement, 
        _index: number, 
        private readonly countriesApi: CountriesApi = cApi,
        private readonly notificationApi: NotificationApi = nApi
    ) {
        super(countrySelectorElement, _index);

        void this.init();
    }

    async init() {
        try {
            this.store.countries = await this.countriesApi.getCountries({ url: window.location.href });
        } catch (error) {
            console.error("Error fetching countries:", error);
            return;
        }

        this.countrySelectorElement.innerHTML = languageListTemplate(this.store.countries);

        const activeCountry = this.store.countries.find(country => country.active);

        if (
            activeCountry === undefined || 
            activeCountry.countryTitle !== "Securitas.com"
        ) {
            return;
        }

        const visitorCountryCode = await this.notificationApi.getVisitorCountryCode();

        if (visitorCountryCode === "Not_Found") {
            return;
        }

        const recommendedCountryCodes = cookie.getCookie("NotificationPopup");

        const visitorCountries = this.store.countries.filter(
            (country) => country.countryCode === visitorCountryCode
        );

        const countriesWithLanguageNotRecommended = visitorCountries.filter(visitorCountry => visitorCountry.languages.some(language => !recommendedCountryCodes.includes(language.code)));

        if (countriesWithLanguageNotRecommended.length > 0) {
            this.renderNotification(
                countriesWithLanguageNotRecommended
            );
        }
    }

    renderNotification(countries: Country[]) {
        const notifications = document.querySelector<HTMLDivElement>("#notifications");

        if (!notifications) {
            return;
        }

        notifications.innerHTML = notificationTemplate(countries);

        const closeButtons = document.querySelectorAll(".notification__close");

        closeButtons.forEach((closeButton) => {
            closeButton.addEventListener("click", this.handleCloseButtonClick);
        });
    }

    handleCloseButtonClick = (e: Event) => {
        const cookieLanguageNotification = cookie.getCookie(
            "NotificationPopup"
        );

        if (!e.target || !(e.target instanceof HTMLButtonElement)) {
            return;
        }

        (e.target.parentNode as HTMLElement).remove();

        const countryCode = e.target.dataset.code;

        if (!countryCode) {
            return;
        }

        let recommendedCountryCodes: string[] = [];

        if (cookieLanguageNotification != "") {
            recommendedCountryCodes = cookieLanguageNotification.split(",");
        }

        recommendedCountryCodes.push(countryCode);
        cookie.setCookie("NotificationPopup", recommendedCountryCodes.join(","), 30);
    }
}
